export const quiniela = {
  quinielaTitle: "竞猜",
  quinielaHeroTitle: "世界杯竞猜",
  quinielaSubtitle: "2026年国际足联世界杯",
  quinielaDescription: "预测世界杯比赛结果，赢取奖品",
  quinielaPremiumLabel: "世界杯竞猜票",
  quinielaMiniBanner: "世界杯转盘",
  quinielaBalance: "余额",
  quinielaActiveRound: "当前轮次",
  quinielaMatches: "比赛",
  quinielaRounds: "轮次",
  quinielaLeaderboard: "排名",
  quinielaMyPredictions: "我的预测",
  quinielaMyTickets: "我的票券",
  quinielaPlayTab: "预测",
  quinielaTicketTab: "我的票券",
  quinielaRulesTab: "规则",
  quinielaRulesTabHint: "快速指南",
  quinielaTabsNav: "竞猜主导航",
  quinielaHowToPlayCta: "如何参与",
  quinielaChooseTournament: "选择赛事",
  quinielaChooseRound: "选择轮次",
  quinielaPlayNow: "立即参与",
  quinielaViewTicket: "查看票券",
  quinielaReviewTicket: "复核票券",
  quinielaReviewEyebrow: "复核",
  quinielaConfirmBet: "确认投注",
  quinielaEditPicks: "修改选择",
  quinielaSubmit: "提交预测",
  quinielaSubmitSuccess: "预测提交成功",
  quinielaSubmitError: "提交预测失败",
  quinielaLoadError: "无法加载本轮比赛。",
  quinielaRetry: "重试",
  quinielaTicketConfirmed: "票券已确认。",
  quinielaTicketConfirmedTitle: "票券已确认",
  quinielaTicketId: "票券编号",
  quinielaTicketIdPending: "生成中",
  quinielaConfirmedAt: "确认时间",
  quinielaDeadline: "预测截止时间",
  quinielaEntryFee: "参赛费用",
  quinielaPrizePool: "奖金池",
  quinielaCurrentBalance: "当前余额",
  quinielaBalanceAfter: "确认后余额",
  quinielaPoints: "积分",
  quinielaRank: "排名",
  quinielaHomeWin: "主胜",
  quinielaDraw: "平局",
  quinielaAwayWin: "客胜",
  quinielaMatchDay: "比赛日",
  quinielaGroup: "小组",
  quinielaGroupStage: "小组赛",
  quinielaRound32: "三十二强",
  quinielaRound16: "十六强",
  quinielaQuarterFinals: "四分之一决赛",
  quinielaSemiFinals: "半决赛",
  quinielaThirdPlace: "三四名决赛",
  quinielaFinal: "决赛",
  quinielaVs: "对",
  quinielaPenalties: "点球",
  quinielaPrediction: "预测",
  quinielaResult: "结果",
  quinielaCorrect: "正确",
  quinielaIncorrect: "错误",
  quinielaPending: "待定",
  quinielaRoundOpen: "开放中",
  quinielaRoundLocked: "已锁定",
  quinielaRoundScored: "已评分",
  quinielaRoundUpcoming: "即将开始",
  quinielaRoundClosedTitle: "本轮已关闭。",
  quinielaRoundClosedDescription: "本轮已截止，无法继续修改或提交预测。",
  quinielaNoRounds: "暂无可用轮次",
  quinielaNoTicketYet: "你还没有生成票券。",
  quinielaNoTicketDescription: "完成全部 1X2 选择后，先复核票券再确认。",
  quinielaStartTicket: "开始选号",
  quinielaAlreadySubmitted: "您已提交本轮预测",
  quinielaSelectAll: "请为每场比赛选择预测",
  quinielaMissingPicks: "还有 {{count}} 场比赛未完成。",
  quinielaMissingPicksShort: "剩余 {{count}} 个选择",
  quinielaTabReady: "可提交",
  quinielaTabWaiting: "暂无开放轮次",
  quinielaTabLocked: "预测已锁定",
  quinielaTabPendingCount: "剩余 {{count}} 项",
  quinielaTabTicketDraft: "草稿",
  quinielaTabTicketEmpty: "为空",
  quinielaTabTicketConfirmed: "已确认",
  quinielaTabLeaderboardLive: "竞赛进行中",
  quinielaTabLeaderboardReady: "结果已就绪",
  quinielaTournamentLeaderboard: "总排行榜",
  quinielaRoundLeaderboard: "本轮排行榜",
  quinielaFree: "免费",
  quinielaUser: "用户",
  quinielaTotalPoints: "总积分",
  quinielaMyPosition: "我的排名",
  quinielaYourPick: "你的选择",
  quinielaPredictionsLocked: "预测已锁定。",
  quinielaInsufficientBalanceTitle: "余额不足。",
  quinielaInsufficientBalanceDescription: "你需要更多余额才能确认这张票券。",

  quinielaHowToPlayTitle: "如何参与竞猜？",
  quinielaHowToPlayStep1Title: "1. 选择轮次",
  quinielaHowToPlayStep1Desc: "选择2026年国际足联世界杯的开放比赛日。每轮包含同一天进行的多场比赛。",
  quinielaHowToPlayStep2Title: "2. 预测结果",
  quinielaHowToPlayStep2Desc: "为每场比赛选择：1（主队胜）、X（平局）或2（客队胜）。您必须预测该轮的所有比赛。",
  quinielaHowToPlayStep3Title: "3. 支付并确认",
  quinielaHowToPlayStep3Desc: "如果该轮有参赛费用，提交预测时将从您的游戏余额中扣除。提交后无法修改预测。",
  quinielaHowToPlayStep4Title: "4. 获得积分",
  quinielaHowToPlayStep4Desc: "每个正确预测值1分。该轮所有比赛结束后，积分将自动计算。",
  quinielaHowToPlayStep5Title: "5. 查看排行榜",
  quinielaHowToPlayStep5Desc: "查看本轮排行榜和锦标赛总排名。顶尖预测者将赢得奖金池中的奖品！",
  quinielaHowToPlayNote: "预测在每轮第一场比赛开球前关闭。请确保及时提交您的预测。",
};
